$(function() {
    $('#race-date').datepicker({
        dateFormat: "yy-mm-dd"
    });
    $( document ).ready(function() {

        var race_init = $('#race-list').val();
        var sport_init = $('#sport-list').val();

        if(race_init == 'other') {
            $('.race-date-wrapper, .race-name-wrapper').show();
        } else {
            $('.race-date-wrapper, .race-name-wrapper').hide();
        }

        if(sport_init == 'other') {
            $('.race-sport-other-wrapper').show();
        } else {
            $('.race-sport-other-wrapper').hide();
        }

        $('#race-list').on('change', function() {
            var race = $('#race-list').val();

            if(race == 'other') {
                $('.race-date-wrapper, .race-name-wrapper').show();
            } else {
                $('.race-date-wrapper, .race-name-wrapper').hide();
            }

            console.log(race);
            if(race != 'select race' && race != 'other') {
                var race_date = $('#race-list option:selected').data('race-date').replace('\n','');
                var race_name = $('#race-list option:selected').data('race-name').replace('\n','');
                var formattedDate = new Date(race_date);
                var d = ("0" + formattedDate.getDate()).slice(-2)
                var m =  ("0" + (formattedDate.getMonth() + 1)).slice(-2)
                var y = formattedDate.getFullYear();
                
                console.log('update cart with - ', { attributes : { "race-date": y + '-' + m + '-' + d, "race-name": race_name, "race": "" } });
                $.post('/cart/update.js', { attributes : { "race-date": y + '-' + m + '-' + d, "race-name": race_name, "race": "" } } );
            } else if (race == 'select race') {
                $.post('/cart/update.js', { attributes : { "race-date": '', "race-name": '', "race": '' } } );
            }
        });

        $('#race-date, #race-name').on('change keyup', function() {
            if ($('#race-date').val() != '') {
                $.post('/cart/update.js', { attributes : { "race-date": $('#race-date').val(), "race": "other" } } );
            }
            if ($('#race-name').val() != '') {
                $.post('/cart/update.js', { attributes : { "race-name": $('#race-name').val(), "race": "other" } } );
            }
        });

        $('#sport-list').on('change', function() {
            var sport = $('#sport-list').val();

            if(sport == 'other') {
                $('.race-sport-other-wrapper').show();
            } else {
                $('.race-sport-other-wrapper').hide();
            }

            console.log(sport);
            if(sport != 'select sport' && sport != 'other') {
                var sport_name = $('#sport-list option:selected').data('sport').replace('\n','');
                
                console.log('update cart with - ', { attributes : { "sport-name": sport_name } });
                $.post('/cart/update.js', { attributes : { "sport-name": sport_name } } );
            } else if (sport == 'select sport') {
                $.post('/cart/update.js', { attributes : { "sport-name": '' } } );
            }
        });

        $('#sport-other').on('change keyup', function() {
            if ($('#sport-other').val() != '') {
                $.post('/cart/update.js', { attributes : { "sport-other": $('#sport-other').val(), "sport-name": "other" } } );
            }
        });
    });
})